import React, { useState, useEffect, useRef } from "react"
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Card, CardBody, Container, Button, Input } from "reactstrap"
import { ProgressSpinner } from "primereact/progressspinner"
import AuthenticationApi from "Api/AuthenticationApi"
import defaultAvatar from "assets/images/man.png"
import "./UserPostFeed.scss"
import moment from "moment"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Menu } from "primereact/menu"
import { Toast } from "primereact/toast"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const PostHeader = ({ post, handleDeleteConfirmation, setGabId }) => {
  const [showMore, setShowMore] = useState([])
  const op = useRef(null)
  const accessToken = localStorage.getItem("accessToken")

  const menuRef = useRef(null)
  const menuItems = [
    {
      label: "Edit",
      icon: "ion ion-md-create",
      className: "w-100 px-3 py-2",
      command: () => {
      
      },
    },
    {
      label: "Delete",
      icon: "ion ion-md-trash",
      className: "w-100 px-3 py-2",
      command: () => {
        handleDeleteConfirmation("gab")
        setGabId(post._id)
        
      },
    },
  ]

  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="d-flex align-items-center mb-3">
        <img
          src={post.postedByDetails?.profilePicture || defaultAvatar}
          alt="Profile"
          className="rounded-circle me-2"
          width="40"
          height="40"
        />
        <div>
          <h6 className="mb-0">{post.postedByDetails?.userName}</h6>
          <small className="text-muted">
            {moment(post.postedOn).fromNow()}
          </small>
        </div>
      </div>
      <div
        className="d-flex align-items-center p-2 cursor-pointer"
        onClick={e => {
          e.stopPropagation()
          menuRef.current.toggle(e)
        }}
      >
        <i className="ion ion-md-more" style={{ fontSize: "1.5rem" }}></i>
        <Menu
          model={menuItems}
          popup
          ref={menuRef}
          style={{
            width: "150px",
            padding: "0",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
            alignItems: "center",
            backgroundColor: "var(--surface-overlay)",
            color: "var(--text-color)",
          }}
          className="custom-menu"
          menuItemTemplate={item => item.template && item.template(item)}
        />
      </div>
    </div>
  )
}

const PostContent = ({ post }) => {
  const [videoError, setVideoError] = useState(false)
  const [imageError, setImageError] = useState(false)

  const handleVideoError = e => {
    console.error("Video Error:", e)
    setVideoError(true)
  }

  const handleImageError = e => {
    console.error("Image Error:", e)
    setImageError(true)
  }

  return (
    <div className="post-content mb-3">
      <h6 className="mb-2">{post.topic}</h6>
      <p className="mb-3">{post.description}</p>
      {post.contentLink && post.contentType === "Video" ? (
        videoError ? (
          <div className="alert alert-warning" role="alert">
            Unable to load the video.
          </div>
        ) : (
          <video
            src={post.contentLink}
            controls
            preload="metadata"
            className="img-fluid rounded mb-3"
            style={{ width: "100%", maxHeight: "500px" }}
            onError={handleVideoError}
          >
            <source src={post.contentLink} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        )
      ) : post.contentLink && post.contentType === "Img" ? (
        imageError ? (
          <div className="alert alert-warning" role="alert">
            Unable to load the image.
          </div>
        ) : (
          <img
            src={post.contentLink}
            alt="Post Content"
            className="img-fluid rounded mb-3"
            onError={handleImageError}
          />
        )
      ) : null}
    </div>
  )
}

const InteractionButtons = ({ post, toggleLikes, toggleComments }) => (
  <div className="d-flex gap-3 mb-3">
    <span
      role="button"
      className="cursor-pointer d-flex align-items-center"
      onClick={() => toggleLikes(post._id)}
    >
      <i className="ion ion-md-heart text-danger me-1"></i>
      {post.likes?.length || 0} likes
    </span>
    <span
      role="button"
      className="cursor-pointer d-flex align-items-center"
      onClick={() => toggleComments(post._id)}
    >
      <i className="ion ion-md-chatboxes text-primary me-1"></i>
      {post.comments?.length || 0} comments
    </span>
  </div>
)

const LikesSection = ({ post, expandedLikes, toggleLikes }) => {
  if (!expandedLikes[post._id] || !post.likes?.length) return null

  return (
    <div className="likes-section border-top pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2 px-4">
        <h6 className="mb-0 p-1">
          Liked by {post.likes.length}{" "}
          {post.likes.length === 1 ? "person" : "people"}
        </h6>
        <button
          type="button"
          className="btn-close small"
          onClick={() => toggleLikes(post._id)}
        />
      </div>
      <div className="likes-list">
        {post.likes.map((like, index) => (
          <div key={index} className="like-item d-flex align-items-center p-2">
            <img
              src={like.likedBy?.profilePicture || defaultAvatar}
              alt="Profile"
              className="rounded-circle me-2"
              width="32"
              height="32"
            />
            <div className="like-info">
              <h6 className="mb-0 fs-6">{like.likedBy?.userName}</h6>
              <small className="text-muted">
                {moment(like.likedOn).fromNow()}
              </small>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const CommentsSection = ({
  post,
  expandedComments,
  setCommentData,
  selectedComment,
  setSelectedComment,
  handleDeleteConfirmation,
}) => {
  const menuRefs = useRef({})
  if (!expandedComments[post._id] || !post.comments?.length) return null

  const getMenuItems = comment => [
    {
      label: "Edit",
      icon: "ion ion-md-create",
      className: "w-100 px-3 py-2",
      command: () => {
       
      },
    },
    {
      label: "Delete",
      icon: "ion ion-md-trash",
      className: "w-100 px-3 py-2",
      command: () => {
        handleDeleteConfirmation("comment")
        setCommentData({
          gabId: post._id,
          commentId: comment._id,
        })
        // setSelectedComment(comment)
        // toggle()
      },
    },
  ]

  return (
    <div className="comments-section border-top pt-3">
      {post.comments.map((comment, index) => {
        // Ensure we have a ref for this comment
        if (!menuRefs.current[comment._id]) {
          menuRefs.current[comment._id] = React.createRef()
        }

        return (
          <div
            key={index}
            className="comment-item d-flex mb-2"
            onClick={() => setSelectedComment(comment)}
          >
            <img
              src={comment.commentedBy?.profilePicture || defaultAvatar}
              alt="Profile"
              className="rounded-circle me-2"
              width="32"
              height="32"
            />
            <div className="comment-content">
              <h6 className="mb-0 fs-6">{comment.commentedBy?.userName}</h6>
              <p className="mb-1 small">{comment.comment}</p>
              <small className="text-muted">
                {moment(comment.commentedOn).fromNow()}
              </small>
            </div>
            <div
              className="d-flex align-items-center p-2"
              onClick={e => {
                e.stopPropagation() // Prevent click from propagating to parent
                menuRefs.current[comment._id].current.toggle(e)
              }}
            >
              <i className="ion ion-md-more" style={{ fontSize: "1rem" }}></i>
              <Menu
                model={getMenuItems(comment)}
                popup
                ref={menuRefs.current[comment._id]}
                style={{
                  width: "150px",
                  padding: "0",
                  border: "1px solid #dee2e6",
                  borderRadius: "6px",
                  alignItems: "center",
                  backgroundColor: "var(--surface-overlay)",
                  color: "var(--text-color)",
                }}
                className="custom-menu"
                menuItemTemplate={item => item.template && item.template(item)}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

const PostCard = ({
  post,
  expandedLikes,
  expandedComments,
  toggleLikes,
  toggleComments,
  handleDeleteConfirmation,
  setGabId,
  selectedComment,
  setSelectedComment,
  setCommentData,
}) => (
  <Card key={post._id} className="mb-4">
    <CardBody>
      <PostHeader
        post={post}
        handleDeleteConfirmation={handleDeleteConfirmation}
        setGabId={setGabId}
      />
      <PostContent post={post} />
      <InteractionButtons
        post={post}
        toggleLikes={toggleLikes}
        toggleComments={toggleComments}
      />
      <LikesSection
        post={post}
        expandedLikes={expandedLikes}
        toggleLikes={toggleLikes}
      />
      <CommentsSection
        post={post}
        expandedComments={expandedComments}
        selectedComment={selectedComment}
        setSelectedComment={setSelectedComment}
        handleDeleteConfirmation={handleDeleteConfirmation}
        setCommentData={setCommentData}
      />
    </CardBody>
  </Card>
)

const UserPosts = ({ userData }) => {
  document.title = "User Post Feed"
  // const { userId } = useParams()
  const userId = userData.userId
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [posts, setPosts] = useState([])
  const accessToken = localStorage.getItem("accessToken")
  const [expandedComments, setExpandedComments] = useState({})
  const [expandedLikes, setExpandedLikes] = useState({})
  const [hasMore, setHasMore] = useState(true)
  const [modal, setModal] = useState(false)
  const [modalType, setModalType] = useState("")
  const [commentData, setCommentData] = useState({ gabId: "", commentId: "" })
  const [selectedComment, setSelectedComment] = useState(null)
  const toast = useRef(null)

  const toggle = () => setModal(!modal)

  const breadcrumbItems = [
    { label: "Home", url: "/" },
    { label: "User Profile  ", url: "/view-user" },
    { label: "User Posts", url: `/userPosts/${userId}` },
  ]

  // const location = useLocation()
  // const { userData } = location.state

  const toggleComments = postId => {
    setExpandedComments(prev => ({
      ...prev,
      [postId]: !prev[postId],
    }))
  }
  const toggleLikes = postId => {
    setExpandedLikes(prev => ({
      ...prev,
      [postId]: !prev[postId],
    }))
  }

  // const handleLikesClick = likes => {
  //   setSelectedLikes(likes)
  //   setShowLikes(true)
  // }

  const [otp, setOtp] = useState("")
  const [reason, setReason] = useState("")
  const [gabId, setGabId] = useState("")

  const handleConfirmDelete = (type, gabId, commentId) => {
    setModalType(type)
    if (type === "comment") {
      setCommentData({
        gabId: gabId,
        commentId: commentId,
      })
    } else if (type === "gab") {
      setGabId(gabId)
    }
    toggle()
  }

  const handleDeleteconfirmButton = () => {
    if (gabId) {
      handleConfirmDeleteGab()
    } else if (commentData.gabId) {
      handleConfirmDeleteComment()
    }
  }

  const handleDeleteConfirmation = deleteType => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const payload = {
      deleteType: deleteType,
    }

    AuthenticationApi.deleteGabOtpConfirmation(payload, config)
      .then(response => {
        toggle()
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "OTP to admin send successfully",
          life: 3000,
        })
        // toast.success("OTP to admin send successfully")
      })
      .catch(error => {
        console.error("Error sending OTP to admin:", error)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            error.response?.data?.message || "Failed to send OTP to admin",
        })
        // toast.error("Failed to send OTP to admin")
        toggle()
      })
  }

  const handleConfirmDeleteGab = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    const payload = {
      otp,
      reason,
    }

    AuthenticationApi.confirmDeleteGab(gabId, payload, config)
      .then(response => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Gab deleted successfully",
          life: 3000,
        })
        // toast.success("Gab deleted successfully")
        toggle()
        getUserPosts()
        setOtp("")
        setReason("")
      })
      .catch(error => {
        console.error("Error deleting gab:", error)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message || "Failed to delete gab",
          life: 3000,
        })
        // toast.error("Failed to delete gab")
        setOtp("")
        setReason("")
        toggle()
      })
  }
  const handleConfirmDeleteComment = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        gabId: commentData.gabId,
        commentId: commentData.commentId,
      },
    }

    const payload = {
      deletedReason: reason,
      otp: otp,
    }

    AuthenticationApi.deleteComment(payload, config)
      .then(response => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Comment deleted successfully",
          life: 3000,
        })
        // toast.success("Comment deleted successfully")
        toggle()
        getUserPosts()
        setOtp("")
        setReason("")
      })
      .catch(error => {
        console.error("Error deleting comment:", error)
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message || "Failed to delete comment",
          life: 3000,
        })
        // toast.error(error.response?.data?.message || "Failed to delete comment")
        toggle()
        setOtp("")
        setReason("")
      })
  }
  const getUserPosts = async () => {
    try {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      const response = await AuthenticationApi.getUserPostFeed(userId, config)
      if (response.data.status) {
        setPosts(response.data.data.gabs)
      }
    } catch (error) {
     
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch posts",
        life: 3000,
      })
      // toast.error("Failed to fetch posts")
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (userId) {
      getUserPosts()
    }
  }, [userId])

  const renderPosts = () => {
    if (!posts?.length) {
      return (
        <div className="text-center p-4">
          <h5>No posts found</h5>
        </div>
      )
    }

    return posts.map(post => (
      <PostCard
        key={post._id}
        post={post}
        selectedComment={selectedComment}
        setSelectedComment={setSelectedComment}
        expandedLikes={expandedLikes}
        expandedComments={expandedComments}
        toggleLikes={toggleLikes}
        toggleComments={toggleComments}
        handleDeleteConfirmation={handleDeleteConfirmation}
        setGabId={setGabId}
        setCommentData={setCommentData}
      />
    ))
  }

  return (
    <>
      <Toast ref={toast} position="top-right" life="3000" />
      <Container className="pb-4">
        {/* <div className="d-flex justify-content-between align-items-center mb-4">
          <CustomBreadCrumb
            data={breadcrumbItems}
            pageTitle={`${userData.firstName}  ${userData.lastName}'s Posts`}
          />
          <Button
            color="secondary"
            className="d-flex align-items-center gap-2"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div> */}
        {/* 
      <Dialog
        header="Likes"
        visible={showLikes}
        onHide={() => setShowLikes(false)}
        style={{ width: "90%", maxWidth: "400px" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      >
        <div className="likes-list">
          {selectedLikes?.map((like, index) => (
            <div
              key={index}
              className="like-item d-flex align-items-center p-2"
            >
              <img
                src={like.userDetails?.profilePicture || defaultAvatar}
                alt="Profile"
                className="rounded-circle me-3"
                width="40"
                height="40"
              />
              <div>
                <h6 className="mb-0">{like.userDetails?.userName}</h6>
                <small className="text-muted">{like.userDetails?.email}</small>
              </div>
            </div>
          ))}
          {selectedLikes?.length === 0 && (
            <div className="text-center text-muted p-3">No likes yet</div>
          )}
        </div>
      </Dialog> */}

        {loading ? (
          <div className="text-center py-5">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="posts-container">
            <div className="row justify-content-center">
              <div className="col-12">{renderPosts()}</div>
            </div>
          </div>
        )}
      </Container>
      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>
          Confirm Delete {modalType === "gab" ? "Post" : "Comment"}
        </ModalHeader>
        <ModalBody>
          <p>
            An OTP has been sent to admin for verification. Please enter the
            OTP.
          </p>

          <div className="confirm-del-form d-flex flex-column gap-4">
            <div className="d-flex flex-column gap-2">
              <label htmlFor="otp">OTP</label>
              <Input
                id="otp"
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={e => setOtp(e.target.value)}
              />
            </div>
            <div className="d-flex flex-column gap-1">
              <label htmlFor="reason">Reason</label>
              <textarea
                id="reason"
                placeholder="Enter Reason"
                className="form-control"
                value={reason}
                onChange={e => setReason(e.target.value)}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
          <Button color="primary" onClick={handleDeleteconfirmButton}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      {/* <ToastContainer /> */}
    </>
  )
}

export default UserPosts
